import { animate, style, transition, trigger } from '@angular/animations';
import { BooleanInput } from '@angular/cdk/coercion';
import { booleanAttribute, Component, input, model, signal } from '@angular/core';
import { IconName, provideIcons } from '@ng-icons/core';
import {
  lucideArrowDown,
  lucideArrowUp,
  lucideChevronDown,
  lucideEllipsisVertical,
  lucideFolderSymlink,
  lucideGripVertical,
  lucidePen,
  lucidePlus,
  lucideTrash,
} from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';

@Component({
  selector: 'app-expansion-panel',
  imports: [HlmButtonImports, HlmTooltipImports, HlmIconImports, HlmDropdownMenuImports, HlmTooltipImports],
  providers: [
    provideIcons({
      lucideChevronDown,
      lucidePen,
      lucideGripVertical,
      lucideEllipsisVertical,
      lucideTrash,
      lucideArrowUp,
      lucideArrowDown,
      lucideFolderSymlink,
      lucidePlus,
    }),
  ],
  templateUrl: './expansion-panel.component.html',
  animations: [
    trigger('expandCollapse', [
      transition(':enter', [
        style({ height: '0', opacity: 0 }),
        animate('300ms ease', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1 }),
        animate('300ms ease', style({ height: '0', opacity: 0 })),
      ]),
    ]),
  ],
})
export class ExpansionPanel<T> {
  readonly titre = input.required<string>();
  readonly draggable = input<boolean, BooleanInput>(false, { transform: booleanAttribute });
  readonly item = input<T>();

  readonly actions = input<ExpansionPanelMenuAction<T>[]>([]);

  edition = signal(false);
  isOpen = model(false);

  toggle() {
    this.isOpen.set(!this.isOpen());
  }
}

export interface ExpansionPanelMenuAction<T> {
  icon: IconName;
  label: string;
  action: (item: T | undefined, autreItem?: any) => void;
  children?: ExpansionPanelMenuAction<T>[];
  shortcut?: string;
  invisible?: (item: T | undefined) => boolean;
  class?: string;
}
